export  const CourseCount = (props) => {
    const { style, course } = props;
    return (
        <p style={style}>該当コース<span style={styles.span}> {course} </span>件</p>
    );
};
const styles = {
    span: {
        fontSize: "25px",
        fontWeight: "bold",
    },
}